import { useEffect, useState } from "react";

const links = [
  { label: "首页", href: "#top" },
  { label: "投稿方式", href: "#methods" },
  { label: "投稿流程", href: "#flow" },
  { label: "投稿守则", href: "#tips" },
  { label: "常见问题", href: "#faq" },
  { label: "关于我们", href: "#about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur shadow-[0_1px_0_0_theme(colors.background.200)]"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-20 max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap">
          <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-chat-3-fill text-lg" aria-hidden="true"></i>
          </span>
          <span className="font-heading text-lg font-bold text-foreground-950 md:text-xl">
            瓜田投递<span className="text-primary-600">站</span>
          </span>
        </a>

        <div className="hidden items-center gap-1 md:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-foreground-950"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <a
            href="#contact"
            className="hidden whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
          >
            立即投稿
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-full text-foreground-950 transition-colors hover:bg-background-100 md:hidden"
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`} aria-hidden="true"></i>
          </button>
        </div>
      </nav>

      {open && (
        <div className="border-t border-background-200/70 bg-background-50 px-4 py-3 md:hidden">
          <div className="flex flex-col gap-1">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="mt-1 whitespace-nowrap rounded-full bg-primary-500 px-4 py-2.5 text-center text-sm font-semibold text-background-50"
            >
              立即投稿
            </a>
          </div>
        </div>
      )}
    </header>
  );
}